import { Fragment } from "react/jsx-runtime";
import DeductionIncompleteProcessing from "./DeductionIncompleteProcessing";
import DeductionIncompleteContent from "./DeductionIncompleteContent";
import useDeductionIncomplete from "./hook/useDeductionIncomplete";

const DeductionIncompleteWrapper = () => {
  const { deductionResolutionStatus, importedFilesAsDocuments } = useDeductionIncomplete();

  const renderContent = () => {
    if (deductionResolutionStatus === "incomplete" || importedFilesAsDocuments.length === 0) return <DeductionIncompleteContent />;
    return <DeductionIncompleteProcessing />;
  };

  return <Fragment>{renderContent()}</Fragment>;
};

export default DeductionIncompleteWrapper;
